import { render, staticRenderFns } from "./ConnectBE.vue?vue&type=template&id=36a90a91&scoped=true"
import script from "./ConnectBE.vue?vue&type=script&lang=js"
export * from "./ConnectBE.vue?vue&type=script&lang=js"
import style0 from "./ConnectBE.vue?vue&type=style&index=0&id=36a90a91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a90a91",
  null
  
)

export default component.exports